var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirmation"},[_c('v-row',{staticClass:"checkClientInfo",attrs:{"no-gutters":""}},_vm._l((_vm.detail),function(rec,index){return _c('v-col',{key:index,class:{
        boxStyle: true,
        boxStyleFirst: index === 0,

        'rounded-bl-lg': index === 0,
        'rounded-br-lg': index === _vm.detail.length - 1
      }},[_c('div',{staticClass:"titleStyle"},[_c('span',{staticClass:"titleText"},[_vm._v(" "+_vm._s(_vm.$t(rec.title)))])]),_c('div',{staticClass:"contentsStyle"},[_vm._t('box' + index,function(){return [_c('InfoSummary',{attrs:{"displayData":rec}})]},{"item":rec})],2)])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }